// <cart-drawer> (§7.6): carrito lateral en un <dialog> modal. Se abre al añadir («cart:open») y desde el icono de la
// cabecera. Escape cierra y el foco vuelve al botón que lo abrió; anuncia «Añadido: …» con role="status".
// Llega pintado del servidor; al abrirlo desde la cabecera se vuelve a pedir el carrito por si cambió en otra pestaña.
// Los avisos van en document y se quitan al desconectarse (el editor de temas vuelve a pintar las secciones).
import { refreshCart } from './cart-store.js';
import { mountCartView, syncHeaderCount } from './cart-view.js';

class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.config = JSON.parse(this.querySelector('[data-cart-config]').textContent);
    this.view = mountCartView(this, this.config);
    this.listeners = [
      ['cart:updated', (event) => syncHeaderCount(this.config.header, event.detail?.cart)],
      ['cart:open', (event) => this.open(event.detail?.opener, event.detail?.announcement)],
      ['click', (event) => this.onCartLink(event)],
    ];
    this.listeners.forEach(([type, listener]) => document.addEventListener(type, listener));
    this.querySelector('[data-close-cart]').addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.dialog.addEventListener('close', () => {
      document.dispatchEvent(new CustomEvent('cart:drawer', { detail: { open: false } }));
      this.opener?.focus();
    });
  }

  disconnectedCallback() {
    this.listeners?.forEach(([type, listener]) => document.removeEventListener(type, listener));
    this.view?.destroy();
  }

  /** El icono de la cabecera abre el carrito lateral; sin JavaScript (o con Ctrl/⌘) lleva a /cart. */
  onCartLink(event) {
    const link = event.target.closest?.('[data-cart-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    this.open(link);
    refreshCart().catch(() => {});
  }

  open(opener, announcement) {
    this.opener = opener ?? document.activeElement;
    if (!this.dialog.open) this.dialog.showModal();
    document.dispatchEvent(new CustomEvent('cart:drawer', { detail: { open: true } }));
    const status = this.querySelector('[data-cart-status]');
    status.textContent = '';
    if (announcement) requestAnimationFrame(() => { status.textContent = announcement; });
    this.querySelector('[data-close-cart]').focus();
  }
}

customElements.define('cart-drawer', CartDrawer);
